export const CaretDownIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
    <path d="M7 9L13 15L19 9" stroke="white" strokeWidth="2" />
  </svg>
);

export const CaretUpIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
    <path d="M19 15L13 9L7 15" stroke="white" strokeWidth="2" />
  </svg>
);
